export default {
    namespaced: true,
    state:{
        info: null
    },
    mutations: {
        updateInfo(state, info) {
            state.info = info;
        }
    },
    actions: {
        /**
         * 登录
         * @param {*} param0 
         */
        login({ commit }){
            commit("updateInfo",{})
        },
        /**
         * 退出
         * @param {*} param0 
         */
        logout({ commit }){
            commit("updateInfo",null)
        }
    }
}